import { Box, Button, Heading, HStack, Icon, Text } from "@chakra-ui/react";
import { useCustomDataType } from "./useCustomDataType";
import { VscTypeHierarchy } from "react-icons/vsc";
import { Table } from "../../components/Table/Table";
import { MdEditOff, MdModeEdit, MdSave } from "react-icons/md";
import { IoMdAdd } from "react-icons/io";

export const CustomDataType = () => {
  const {
    selectedCustomDataType,
    columns,
    columnData,
    isEditing,
    isEdited,
    onEditToggle,
    onAddField,
    onSave,
  } = useCustomDataType();

  return (
    <Box>
      <Box
        bg="rgba(255, 255, 255, 0.05)"
        backdropFilter="blur(20px)"
        borderRadius="20px"
        border="1px solid rgba(255, 255, 255, 0.1)"
        p={6}
      >
        <HStack justifyContent="space-between">
          <HStack>
            <Icon
              as={VscTypeHierarchy as React.ElementType}
              color="green.400"
              boxSize="24px"
            />
            <Heading fontSize="24px" color="white">
              {selectedCustomDataType?.dataTypeName}
            </Heading>
          </HStack>
          <HStack>
            <Icon
              as={
                isEditing
                  ? (MdEditOff as React.ElementType)
                  : (MdModeEdit as React.ElementType)
              }
              onClick={onEditToggle}
              cursor="pointer"
              boxSize="20px"
              color="rgba(255, 255, 255, 0.8)"
              _hover={{ color: "brand.400" }}
            />
            {isEdited ? (
              <Icon
                as={MdSave as React.ElementType}
                cursor="pointer"
                boxSize="20px"
                onClick={onSave}
                color="green.400"
                _hover={{ color: "green.300" }}
              />
            ) : (
              <></>
            )}
          </HStack>
        </HStack>
      </Box>
      <Box
        bg="rgba(255, 255, 255, 0.05)"
        backdropFilter="blur(20px)"
        borderRadius="20px"
        border="1px solid rgba(255, 255, 255, 0.1)"
        mt={4}
      >
        <HStack justifyContent="space-between" p={4}>
          <Heading fontSize="22px" color="white">Fields</Heading>
          {isEditing ? (
            <Icon
              as={IoMdAdd as React.ElementType}
              cursor="pointer"
              boxSize="20px"
              onClick={onAddField}
              color="rgba(255, 255, 255, 0.8)"
              _hover={{ color: "brand.400" }}
            />
          ) : (
            <></>
          )}
        </HStack>
        <Box borderRadius="md">
          <Table
            data={columnData}
            columns={columns}
            paginationEnabled={false}
            centered
          />
        </Box>
      </Box>
    </Box>
  );
};
